module.exports = __webpack_public_path__ + "img/425.4c8f3bd9.jpg";